(function (aimi_business_profile, $, app, undefined) {
  // Private object to hold module internals.
  let __this = {};

  /**
   * Cached jQuery selector for the document's body.
   */
  __this.$body = $('body');

  class BusinessProfile extends TableList {
    constructor(app, container) {
      super(app, container, null, null);
      this.app = app;
      this.container = container;
      this.tabContentOptionsMenu = $('[data-menu="tab_content_options"]', this.container);
      this.tabSamplesMenu = $('[data-menu="tab_samples"]', this.container);
      this.render();
    }

    getTabs(menus) {
      let tabs = {};
      menus.forEach(function (tab) {
        const key = tab.replace(/\s/g, "_").toLowerCase();
        tabs[key] = {'key': tab.replace(/\s/g, "_").replace('&', '').toLowerCase(), 'name': tab};
      })
      return tabs;
    }

    activateTabs($page) {
      const triggerTabList = [].slice.call($page.find('a.nav-link'));
      triggerTabList.forEach(function (triggerEl) {
        let tabTrigger = new bootstrap.Tab(triggerEl);
      })
    }

    renderCallToActions() {
      let mergeTag = {
        'id': 1,
        'tag': '{CALL_OPTION|}',
        'options': 'Text, Call, Call or text, Text message, custom',
        'text': 'Call or text',
        'cta': true,
      }
      let $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{CALL_OPTION|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{NUMBER|}',
        'text': '000-000-0000',
        'cta': true,
      }
      $el = Sample.createInputField(mergeTag);
      $('[data-replace="{NUMBER|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{MEET_OPTION|}',
        'options': 'a consultation, a meeting,  an appointment, custom',
        'text': 'a consultation',
        'cta': true,
      }
      $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{MEET_OPTION|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{PM_OPTION|}',
        'options': 'PM, DM, Direct message, custom',
        'text': 'PM',
        'cta': true,
      }

      $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{PM_OPTION|}"]').replaceWith($el);

    }

    async renderContentOptions() {
      const page = _.template(app.templates['campaign__tab_sub-menus']);
      const menus = [
        'Call to Actions',
        'Mentions',
        'Hashtags'
      ];
      const $page = $(page({'menus': this.getTabs(menus), 'activeTab': 'Call to Actions'}));
      $page.appendTo(this.tabContentOptionsMenu);
      this.renderCallToActions();
      this.activateTabs($page);
      return $page;
    }

    renderMentions() {

    }

    async renderSamples() {
      const page = _.template(app.templates['campaign__tab_sub-menus']);
      const menus = [
        'Over 280 Character Samples',
        'Under 280 Character Samples'
      ];
      const $page = $(page({'menus': this.getTabs(menus), 'activeTab': 'Over 280 Character Samples'}));
      console.log(this.tabSamplesMenu);
      $page.appendTo(this.tabSamplesMenu);
      this.activateTabs($page);
      return $page;
    }

    async render() {
      await this.renderSamples();
    }
  }

  /**
   * Default styling properties for a business profile, including color scheme and font color.
   */
  __this.colorDefaults = {
    'primaryColor': '#ffffff',
    'logoBackground': '',
    'accent1': '#264653',
    'accent2': '#2A9D8F',
    'accent3': '#E9C46A',
    'accent4': '#F4A261',
    'fontColor': '#000000'
  };

  __this.headshot = {};
  __this.logo = {};

  /**
   * Dynamically loads Google Fonts specified by the `fontFamilies` parameter.
   * This allows for the customization of text styles within business profiles.
   *
   * @param {Array<string>} fontFamilies - An array of Google Font family names to be loaded.
   */
  __this.loadGoogleFonts = function (fontFamilies) {
    WebFontConfig = {
      google: {families: fontFamilies}
    };

    (function () {
      var wf = document.createElement('script');
      wf.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js?' + Date.now();
      wf.type = 'text/javascript';
      wf.async = 'true';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(wf, s);
    })();

  };

  const removePlaceholderLoader = () => {
    Utils.getTabContent('#tab_block_1').find('.placeholder-loader').removeClass('placeholder');
    Utils.getTabContent('#tab_block_2').find('.placeholder-loader').removeClass('placeholder');
    Utils.getTabContent('#tab_block_3').find('.placeholder-loader').removeClass('placeholder');
    Utils.getTabContent('#tab_block_4').find('.placeholder-loader').removeClass('placeholder');
  }

  const getGraphicColors = function (requestData) {
    let colorKeysInOrder = _.keys(__this.colorDefaults);
    let newColors = {};
    let exitingColors = {};

    let existingColorsWithoutKeys = app.clone(__this.business_profile.config.graphics.colors);
    _.each(colorKeysInOrder, function (key) {
      exitingColors[key] = existingColorsWithoutKeys.shift();
    });

    _.each(colorKeysInOrder, function (key) {
      // check for undefined instead of empty
      newColors[key] = !_.isUndefined(requestData[key]) ? requestData[key] : exitingColors[key];
    });

    return _.values(newColors);
  }

  aimi_business_profile.hashTagsUpdateCallBack = function (response) {
    // Display a notification with the response message and set the progress to 90%
    app.notifyEl.update({'message': response.message, progress: 90});

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

    // Refresh the view to display the updated hashtags
    aimi_business_profile.view.refresh(response.id).then(function (response) {
      aimi_business_profile.view.renderHashTags(response.data);
    });
  };

  aimi_business_profile.saveCallBack = function (response) {
    // Display a notification with the response message and set the progress to 90%
    //app.notifyEl.update({'message': response.message, progress: 90});
    // Refresh the view to display the updated hashtags
    if (!app.isEmpty(__this.nextStep) && app.isEmpty(__this.dropifyInProgress)) {
      aimi_business_profile.view.navigate(__this.nextStep);
    } else if (!app.isEmpty(__this.dropifyInProgress)) {
      __this.dropifyInProgress = false;
    } else if (app.isEmpty(__this.nextStep)) {

      // Set status to complete
      __this.business_profile.status = 'complete';
      app.apis['business_profile'].save(__this.business_profile);

      const page = _.template(app.templates['business_profile__next-steps']);
      app.infoModal('Next Steps', page({id : __this.businessProfileId}), {dialogClass : 'modal-dialog-scrollable modal-lg'});
    }

    if (app.isEmpty(__this.businessProfileId)) {
      app.redirect(`/business-profile/${response.id}`);
    }
    // aimi_business_profile.view.refresh(response.id).then(function (response) {});
  }

  aimi_business_profile.payloadProcessor = function (requestData) {
    if (!app.isEmpty(__this.businessProfileId)) {
      requestData = {...requestData, ...{id: __this.businessProfileId}};
    } else {
      requestData = {...__this.business_profile, ...requestData};
    }

    const existingInfo = {};
    _.each(requestData, (value, key) => existingInfo[key] = __this.business_profile[key]);

    // If equals
    if (Utils.isEqualIgnoringType(existingInfo, requestData)) {
      return false;
    } else {
      // Else update business profile
      _.each(requestData, (value, key) => __this.business_profile[key] = requestData[key]);
    }

    return requestData;
  }

  aimi_business_profile.preferencesPayloadProcessor = function (requestData) {
    let preferences = [];
    const options = requestData.option;

    const switches = _.flatten(_.map(_.keys(requestData.switch), function (switchKey) {
      return _.map(switchKey.split(','), function (key) {
        return key.trim();
      });
    }));

    _.each(options, function (value, option) {
      const $input = $(`:input[name="option[${option}]"]`);

      let optionVal = {
        tag: option,
        value: value === 'on' ? true : value
      }

      if (value === 'custom') {
        optionVal.value = $input.data('custom-value');
      }

      if ($input.data('cta') === option) {
        optionVal.cta = true;
        if (switches.includes(option)) {
          optionVal.enabled = true;
        }
      }

      preferences.push(optionVal);
    });

    if (app.isEmpty(__this.business_profile.config)) {
      __this.business_profile.config = {};
    }

    if (app.isEmpty(__this.business_profile.config.options)) {
      __this.business_profile.config.options = {};
    }

    if (Utils.isEqualIgnoringType(__this.business_profile.config.options, preferences)) {
      return false;
    } else {
      __this.business_profile.config.options = preferences;
    }
    return __this.business_profile;
  }

  aimi_business_profile.hashTagsPayloadProcessor = function (requestData) {
    if (!app.isEmpty(requestData.hashtags)) {
      // Split the hashtags from the requestData by commas into an array.
      let hashtags = requestData.hashtags.split(',');
      // Remove any duplicate hashtags to ensure uniqueness.
      hashtags = [...new Set(hashtags)];
      // Filter out any empty strings or null values from the array.
      hashtags = hashtags.filter(element => element !== "" && element != null);
      // Map over each hashtag, sanitizing and ensuring each one starts with a '#' character.
      hashtags = hashtags.map(hashtag => '#' + app.sanitizeHashtag(hashtag));
      // Retrieve any existing hashtags from the business profile's configuration.

      if (app.isEmpty(__this.business_profile.config)) {
        __this.business_profile.config = {};
      }

      if (app.isEmpty(__this.business_profile.config.hashtags)) {
        __this.business_profile.config.hashtags = [];
      }

      const existingHashtags = __this.business_profile.config.hashtags;
      // Combine the existing hashtags with the newly processed ones, avoiding duplicates.
      __this.business_profile.config.hashtags = [...existingHashtags, ...hashtags];
    }

    return __this.business_profile;
  }

  aimi_business_profile.hashTagsTabPayloadProcessor = function (requestData) {
    if (app.isEmpty(requestData.switchAddHashTags) && !app.isEmpty(__this.business_profile.config.hashtags)) {
      __this.business_profile.config.hashtags = [];
    } else {
      return false;
    }

    return __this.business_profile;
  }

  aimi_business_profile.graphicsTabPayloadProcessor = function (requestData) {
    if (app.isEmpty(__this.business_profile.config.graphics)) {
      __this.business_profile.config.graphics = {};
    }

    if (app.isEmpty(__this.business_profile.config.graphics.colors)) {
      __this.business_profile.config.graphics.colors = [];
    }

    const graphicColors = getGraphicColors(requestData);

    if (
        Utils.isEqualIgnoringType(__this.business_profile.config.graphics.colors, graphicColors) &&
        __this.business_profile.config.graphics.font === requestData.font_type
    ) {
      return false;
    } else {
      __this.business_profile.config.graphics.colors = getGraphicColors(requestData);
      __this.business_profile.config.graphics.font = requestData.font_type;
    }
    return __this.business_profile;
  }

  aimi_business_profile.logoTabPayloadProcessor = function (requestData) {
    const graphicColors = getGraphicColors(requestData);

    if (
        Utils.isEqualIgnoringType(__this.business_profile.config.graphics.colors, graphicColors) &&
        Utils.isEqualIgnoringType(__this.business_profile.config.graphics.headshot, __this.headshot) &&
        Utils.isEqualIgnoringType(__this.business_profile.config.graphics.image, __this.logo)
    ) {
      return false;
    } else {
      __this.business_profile.config.graphics.colors = graphicColors;
      __this.business_profile.config.graphics.headshot = __this.headshot;
      __this.business_profile.config.graphics.image = __this.logo;
    }
    return __this.business_profile;
  }

  aimi_business_profile.learnPayloadProcessor = function (requestData) {
    let mergeTags = [];

    if (app.isEmpty(__this.business_profile.config)) {
      __this.business_profile.config = {};
    }

    if (app.isEmpty(__this.business_profile.config.mergeTags)) {
      __this.business_profile.config.mergeTags = {};
    }

    const sampleContainers = $("[data-sample-container]");
    sampleContainers.each(function (index) {
      let sampleData = [];
      const sampleNav = $(this);
      const sampleTab = $(sampleNav.attr('data-bs-target'));
      const sample = new Sample(sampleTab);

      sampleData.push({'###index###': index});
      sampleData.push({'###twitter###': sample.getSampleType() === 'under280'});
      sampleData = [...sampleData, ...sample.getData()];
      mergeTags.push(sampleData);
    })

    if (Utils.isEqualIgnoringType(__this.business_profile.config.mergeTags, mergeTags)) {
      return false;
    } else {
      __this.business_profile.config.mergeTags = mergeTags;
    }

    return __this.business_profile;
  }

  /**
   * Defines the view object for the AIMI Business Profile with methods to initialize and refresh the profile data.
   */
  aimi_business_profile.view = {

    setTitle: function (businessProfile) {
      const title = $('.pg-title');
      if(!app.isEmpty(businessProfile)) {
        title.html(businessProfile.name);
      } else {
        title.html("New Business Profile");
      }
    },

    setPageTitle: function (id) {
      let businessProfiles = app.localStorage.getItem('businessProfiles');
      let businessProfile ;
      if(!app.isEmpty(businessProfiles)) {
        businessProfiles = JSON.parse(businessProfiles);
        businessProfile = businessProfiles[id];
        this.setTitle(businessProfile);
      }
    },

    /**
     * Asynchronously refreshes the business profile data by fetching it from the server.
     * @param {String} businessProfileId - The unique identifier for the business profile.
     * @returns {Promise<Object>} The response object containing the refreshed business profile data.
     */
    refresh: async function (businessProfileId) {
      let self = this;
      let response = await app.apis['business_profile'].get(businessProfileId);

      Utils.getTab('#tab_block_2').removeClass('disabled');
      Utils.getTab('#tab_block_3').removeClass('disabled');
      Utils.getTab('#tab_block_4').removeClass('disabled');

      __this.business_profile = response.data;
      this.setTitle(__this.business_profile);
      return response;
    },
    setNextButtonText(tab, text) {
      tab.find('.btn-next-step').text(text);
    },
    navigate(href, checkLastTab = false) {
      if (!app.isEmpty(__this.lastActiveTab) && checkLastTab) {
        const prevTabContent = Utils.getTabContent(__this.lastActiveTab);
        const form = prevTabContent.find('form[name=aimi-business-profile]').eq(0);
        const event = new Event('submit', {
          bubbles: true,    // The event will bubble up through the DOM
          cancelable: true  // The event can be canceled
        });
        form[0].dispatchEvent(event);
      }

      if (app.isEmpty(__this.lastActiveTab) || href !== __this.lastActiveTab) {
        __this.lastActiveTab = href;
      }

      let self = this;
      // Dynamically update header tabs based on selected submenu
      if (href === '#tab_block_1') {
        self.setHeaderTabs([{'icon': 'calendar', 'title': 'Info', 'id': 'tab_info'}]);
        Utils.createAndShowTab('#tab_block_1');
        Utils.createAndShowTab('#tab_info');
        __this.nextStep = '#tab_block_2';
      }
      if (href === '#tab_block_2') {
        self.setHeaderTabs([
          {'icon': 'calendar', 'title': 'Text', 'id': 'tab_preferences_text'},
          {'icon': 'calendar', 'title': 'Hashtags', 'id': 'tab_preferences_hashtags'}
        ]);
        Utils.createAndShowTab('#tab_block_2');
        Utils.hideTabContent('#tab_preferences_hashtags');
        Utils.createAndShowTab('#tab_preferences_text');
        aimi_samples.setSampleContainer(null);
        __this.nextStep = '#tab_preferences_hashtags';
      }

      if (href === '#tab_preferences_text') {
        Utils.createAndShowTab('#tab_preferences_text');
        __this.nextStep = '#tab_preferences_hashtags';
      }

      if (href === '#tab_preferences_hashtags') {
        Utils.createAndShowTab('#tab_preferences_hashtags');
        __this.nextStep = '#tab_block_3';
      }

      if (href === '#tab_block_3') {
        self.setHeaderTabs([
          {'icon': 'calendar', 'title': 'Graphics Settings', 'id': 'tab_graphic_settings'},
          {'icon': 'calendar', 'title': 'Logo and Headshot', 'id': 'tab_logo_headshot'}
        ]);
        Utils.createAndShowTab('#tab_block_3');
        Utils.hideTabContent('#tab_logo_headshot');
        Utils.createAndShowTab('#tab_graphic_settings');
        __this.nextStep = '#tab_logo_headshot';
      }

      if (href === '#tab_graphic_settings') {
        Utils.createAndShowTab('#tab_graphic_settings');
        __this.nextStep = '#tab_logo_headshot';
      }

      if (href === '#tab_logo_headshot') {
        Utils.createAndShowTab('#tab_logo_headshot');
        if (Utils.tabExists('#tab_block_4')) {
          __this.nextStep = '#tab_block_4';
        } else {
          this.setNextButtonText(Utils.getTabContent('#tab_logo_headshot'), 'Save')
          __this.nextStep = null;
        }
      }

      if (href === '#tab_block_4') {
        self.setHeaderTabs([
          {'icon': 'calendar', 'title': 'Samples', 'id': 'tab_samples'},
        ]);
        Utils.createAndShowTab('#tab_block_4');
        Utils.createAndShowTab('#tab_samples');
        __this.nextStep = null;
        self.setSampleActiveTab();
      }


      if (checkLastTab) {
        __this.nextStep = href;
      }
    },

    getCampaignByIndustry: async function (id) {
      const self = this;
      const tab = Utils.getTab('#tab_block_4');
      tab.addClass(' m-progress m-progress-start');
      __this.getCampaignByIndustry = app.apis['business_profile'].getCampaignByIndustry(id).done(function (response) {
        tab.removeClass(' m-progress m-progress-start ');
        self.buildSamples(JSON.parse(response.samples), [], response.options);
      }).fail(function (response) {

      });
    },

    /**
     * Initializes the business profile view, setting up elements, event listeners, and loading profile data if in edit mode.
     * @param {String} businessProfileId - The unique identifier for the business profile to initialize, if applicable.
     */
    init: function (businessProfileId) {
      let __view = this;
      this.setPageTitle(businessProfileId);
      __this.businessProfileId = businessProfileId;
      // Cache frequently used elements
      __this.$form = $('form[name=aimi-business-profile]');
      __this.$headShotDropify = $('.dropify-headshot');
      __this.$logoDropify = $('.dropify-logo');
      __this.$fontPreview = $('.font-preview-container', __this.$form);
      __this.$fontType = $("select[name=font_type]", __this.$form);
      __this.$resetColors = $('.reset-color-to-defaults');
      __this.$industry = $(":input[name=industry]", __this.$form);

      __this.businessProfileEditor = new BusinessProfile(app, __this.$form);

      // Sample containers for character count variations
      __this.$samplesContainerOver280 = $('.samples-container-over280');
      __this.$samplesContainerUnder280 = $('.samples-container-under280');

      // Preferences Hashtags
      __this.$btnAddHashTag = $('.btn-add-hashtag', __this.$form);
      __this.$hashtagsContainer = $('[data-hashtags]', __this.$form);
      __this.$switchHashTag = $('#customHashtagSwitch');

      // Initialize custom scrollbars
      new SimpleBar(document.getElementById('tab_block_1'), {autoHide: true});
      new SimpleBar(document.getElementById('tab_block_2'), {autoHide: true});
      new SimpleBar(document.getElementById('tab_block_3'), {autoHide: true});
      new SimpleBar(document.getElementById('tab_block_4'), {autoHide: true});

      // Initialize tabs
      __view.infoTab();
      __view.graphicsTab();
      __view.preferencesTab();
      __view.learnTab();

      Utils.getTab('#tab_block_2').addClass('disabled');
      Utils.getTab('#tab_block_3').addClass('disabled');
      Utils.getTab('#tab_block_4').addClass('disabled');

      // If in edit mode, refresh the business profile data
      if (__this.businessProfileId) {
        const currentStep = app.localStorage.getItem('next-step') || '#tab_block_1';
        app.localStorage.removeItem('next-step');
        __view.navigate(currentStep);

        __this.aysncRequstsInfoTabGetIndustries.then(function () {
          __view.refresh(__this.businessProfileId).then(function (response) {
            __view.setValues(response.data);
            removePlaceholderLoader();
          });
        });
      } else {
        // Set default header tabs and show the first tab
        __view.navigate('#tab_block_1')
        removePlaceholderLoader();
        __this.business_profile = {};

        app.localStorage.setItem('next-step', '#tab_block_2');
      }


      // Setup event listeners for tab navigation
      $(document).off("click.bs.tab").on("click.bs.tab", ".sub-menu a[data-bs-toggle='tab'], .header-tabs-start a[data-bs-toggle='tab']", function (e) {
        let $this = $(this);
        const href = $this.attr('href');
        __view.navigate(href, true);
      });
    },
    renderPreferences: function () {
      let mergeTag = {
        'id': 1,
        'tag': '{CALL_OPTION|}',
        'options': 'Text, Call, Call or text, Text message, custom',
        'text': 'Call or text',
        'cta': true,
      }
      let $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{CALL_OPTION|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{NUMBER|}',
        'text': '000-000-0000',
        'cta': true,
      }
      $el = Sample.createInputField(mergeTag);
      $('[data-replace="{NUMBER|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{MEET_OPTION|}',
        'options': 'a consultation, a meeting,  an appointment, custom',
        'text': 'a consultation',
        'cta': true,
      }
      $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{MEET_OPTION|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{PM_OPTION|}',
        'options': 'PM, DM, Direct message, custom',
        'text': 'PM',
        'cta': true,
      }

      $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{PM_OPTION|}"]').replaceWith($el);

    },
    infoTab: function () {
      const self = this;
      const $industryOptionGroup = $('<optgroup label="Industry" ></optgroup>').appendTo(__this.$industry);
      const $demoOptionGroup = $('<optgroup label="Company" ></optgroup>').appendTo(__this.$industry);
      const $formControlLoader = __this.$industry.closest('.form-control-loader');

      __this.aysncRequstsInfoTabGetIndustries = app.apis['business_profile'].getIndustries().done(function (response) {
        $.each(response.data, function (index, value) {
          const $option = $('<option />').attr('value', value.id).html(value.name);
          value.demo === '1' ? $option.appendTo($demoOptionGroup) : $option.appendTo($industryOptionGroup);
        });
        $formControlLoader.removeClass('m-progress');
        __this.$industry.select2({
          theme: 'bootstrap-5', templateResult: __this.fontFormatState
        });
      }).fail(function (response) {

      });

      __this.$industry.off('change').on('change', function () {
        const id = $(this).val();
        self.getCampaignByIndustry(id).then(function () {

        });
      });
    },
    preferencesTab: function () {
      let __view = this;
      __view.renderPreferences();

      aimi_samples.init();

      // Setup event listeners for tab navigation
      $(document).off("click.bs.sample-navigation").on("click.bs.sample-navigation", ".sample-navs [data-bs-toggle]", function (e) {
        const $tab = __view.setSampleActiveTab();
        console.log($tab);
      });

      /**
       * Initializes or re-initializes the click event listener on the button for adding new hashtags.
       *
       * When the button is clicked, it presents the user with an input prompt to enter one or several
       * new hashtags. The hashtags should be separated by commas if multiple. Upon submitting the form
       * in the prompt, the entered hashtags are sent to a specified API endpoint for saving. After the
       * hashtags are successfully saved, a callback function is triggered to update the UI accordingly.
       *
       */
      __this.$btnAddHashTag.off('click').on('click', function () {
        app.inputPrompt({
          type: 'input',
          val: '',
          title: 'New Hashtag',
          saveButtonText: 'Save Hashtag',
          inputLabel: 'Type in one or several hashtags, separating them with a comma.',
          inputName: 'hashtags',
          placeHolder: 'i.e. #PreBuilt, #Aimi',
          payloadProcessor: 'aimi_business_profile.hashTagsPayloadProcessor',
          saveApi: 'business_profile.save',
          saveApiCallBack: 'aimi_business_profile.hashTagsUpdateCallBack'
        }).then(function (response) {

        });
      });

      /**
       * Initializes or re-initializes the click event listener for deleting hashtags.
       * When the delete button within a hashtag row is clicked, it prompts the user
       * for confirmation. If confirmed, it proceeds to delete the hashtag from the
       * business profile configuration and updates the view accordingly.
       */
      $(document).off('click.aimi_hashtags_delete').on('click.aimi_hashtags_delete', 'tr.hashtag-row .btn-delete', function (e) {
        // Retrieve hashtag from the data attribute of the clicked button.
        let hashtag = $(this).data('hashtag');

        // Prompt the user for confirmation before deletion.
        app.confirm("Delete Hashtag?", "Are you sure you want to delete this Hashtag?").then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            let array = __this.business_profile.config.hashtags;
            let valueToDelete = hashtag;
            // Filter out the hashtag to be deleted.
            __this.business_profile.config.hashtags = array.filter(item => item !== '#' + app.sanitizeHashtag(valueToDelete));

            // Update the business profile with the new hashtags array.
            app.apis['business_profile'].update(__this.business_profile.id, __this.business_profile).done(function (response) {
              // Refresh the view to display the updated hashtags.
              aimi_business_profile.view.refresh(response.id).then(function (response) {
                app.doButtonReset($button);
                app.hideModal($modal);
                aimi_business_profile.view.renderHashTags(response.data);
              });
            });
          }
        });
      });

      /**
       * Attaches or re-attaches a change event listener to hashtag checkboxes.
       * When the state of any hashtag checkbox changes, it checks if any hashtags
       * are selected for deletion. If so, it prompts the user for bulk deletion confirmation.
       * Upon confirmation, it deletes the selected hashtags from the business profile
       * configuration and updates the view accordingly.
       */
      $(document).off('change.aimi_hashtags_click').on('change.aimi_hashtags_click', 'tr.hashtag-row input[name="hashtags[]"]', function (e) {

        // Collects all checked hashtags.
        const hashtags = $('input[name="hashtags[]"]:checked').map(function () {
          return '#' + app.sanitizeHashtag(this.value);
        }).get();

        MassActions.destroy();

        console.log(hashtags);
        // Check if any hashtags were selected for deletion.
        if (hashtags.length === 0) {

        } else {
          const massOptions = {
            title: 'Mass Action',
            description: '',
            separator : true,
            deleteButton: {
              text: 'Delete All',
              onClick: (e) => {
                const $button = $(e.currentTarget);
                app.doButtonAction($button);
                let array = __this.business_profile.config.hashtags;
                let valuesToRemove = new Set(hashtags);
                // Filter out the hashtags to be deleted.
                __this.business_profile.config.hashtags = array.filter(item => !valuesToRemove.has(item));

                // Update the business profile with the new hashtags array.
                app.apis['business_profile'].update(__this.business_profile.id, __this.business_profile).done(function (response) {
                  // Refresh the view to display the updated hashtags.
                  aimi_business_profile.view.refresh(response.id).then(function (response) {
                    app.doButtonReset($button);
                    MassActions.destroy();
                    aimi_business_profile.view.renderHashTags(response.data);
                  });
                });

              }
            }
          };

          const massActions = new MassActions(app, $('#customHashtagSwitchCollapse [data-mass-actions]'), massOptions);
          massActions.render();
        }
      });

    },
    learnTab: function () {

    },
    /**
     * Initializes the graphics tab in the UI.
     *
     * This function sets up various graphical elements within a specific tab,
     * including initializing Dropify elements for file inputs, creating color picker
     * groups for different aspects of the user interface, setting up a font type dropdown,
     * and configuring default values for the color pickers. It also sets up event listeners
     * for dynamic UI interactions such as font preview updates on font type selection or search,
     * and a reset functionality for the color pickers to revert to default colors.
     */
    graphicsTab: function () {
      let __view = this; // Reference to the current context stored for later use.

      // Initialize Dropify (a file uploader) for headshot and logo image inputs.
      this.dropify('headshot', __this.$headShotDropify); // Enhance the headshot file input with Dropify.
      this.dropify('logo', __this.$logoDropify); // Enhance the logo file input with Dropify.

      // Add color picker groups for different elements with specific configurations.
      this.addGraphicsGroup($('.group-primary-color', __this.$form), {
        'inputName': 'primaryColor',
        'label': 'Primary Background'
      });
      this.addGraphicsGroup($('.group-logo-background', __this.$form), {
        'inputName': 'logoBackground',
        'label': 'Logo Background'
      });
      this.addGraphicsGroup($('.group-accent1-color', __this.$form), {'inputName': 'accent1', 'label': 'Accent #1'});
      this.addGraphicsGroup($('.group-accent2-color', __this.$form), {'inputName': 'accent2', 'label': 'Accent #2'});
      this.addGraphicsGroup($('.group-accent3-color', __this.$form), {'inputName': 'accent3', 'label': 'Accent #3'});
      this.addGraphicsGroup($('.group-accent4-color', __this.$form), {'inputName': 'accent4', 'label': 'Accent #4'});
      this.addGraphicsGroup($('.group-font-color', __this.$form), {'inputName': 'fontColor', 'label': 'Font Color'});

      // Initialize a dropdown for font type selection using existing select element.
      this.createFontsDropDown($("select[name=font_type]", __this.$form));

      // Set default values for the color picker.
      this.setDefaultsForColorPicker(__this.colorDefaults);

      // Initialize the color picker with configured settings.
      this.initColorPicker();

      // Event listener for when the font type selection changes.
      __this.$fontType.on('change.select2', function () {
        __view.setFontPreview($(this).val()); // Preview the selected font in the preview area.

        // Apply the selected font family directly to the font selection dropdown for immediate visual feedback.
        $('.font-select2-selection .select2-selection__rendered').css({'font-family': $(this).val()});
      });

      /**
       * Attaches an event listener for the 'coloris:pick' event, which is triggered when a color is selected using the Coloris color picker.
       *
       * This function listens for color selection events across the document. When a color is picked from any Coloris color picker,
       * it captures the event, retrieves the relevant information (the element involved and the color chosen), and then calls
       * the `updatePreview` function with this information. The `updatePreview` function is responsible for updating the UI
       * based on the color selected.
       *
       * The event provides two key pieces of data: the HTML element that triggered the color selection and the hex value of the color chosen.
       * This information is used to determine which element's preview needs updating (for instance, changing the background color
       * of a logo or altering the font color) and to pass the appropriate parameters to the `updatePreview` function.
       *
       * Key Operations:
       * - Converts the current element in the event detail to a jQuery object for easy manipulation and access.
       * - Extracts the 'name' attribute of the involved element to identify what type of element it is (e.g., logo background, primary color).
       * - Retrieves the color chosen by the user from the color picker event detail.
       * - Calls the `updatePreview` method with the extracted name and color, which updates the corresponding preview on the page.
       *
       * Note: This listener is set up to handle any 'coloris:pick' event across the document, making it a centralized handler for
       * color changes triggered by the Coloris color picker, simplifying the color selection and update process across the UI.
       */
      document.addEventListener('coloris:pick', event => {
        let $el = $(event.detail.currentEl); // Convert the event's current element to a jQuery object
        const name = $el.attr('name'); // Get the name attribute of the element
        const color = event.detail.color; // Get the color picked
        __view.updatePreview(name, color);
      });

      // Event listener for keyboard navigation within the font type search field.
      $(document).on('keyup', 'span.font-select2-dropdown  input.select2-search__field', function (e) {
        if (e.which === 40 || e.which === 38) { // Check if the key pressed is down (40) or up (38) arrow.
          let $this = $(this); // Reference to the input field.
          setTimeout(function () { // Delay execution to wait for select2 to update its highlighted item.
            let $li = $this.closest('.select2-dropdown').find('li.select2-results__option--highlighted');
            let groupIndex = $li.closest('.select2-results__option--group').index();
            let idx = $li.index();
            const $optGroup = $('optgroup', __this.$fontType).eq(groupIndex);
            let $option = $('option', $optGroup).eq(idx);
            const font = $option.attr('value');
            __view.setFontPreview(font); // Preview the highlighted font in the preview area.
          }, 800);
        }
      });

      // Reset color selections to their default values on button click.
      __this.$resetColors.off('click').on('click', function () {
        __view.setDefaultsForColorPicker(__this.colorDefaults, $(this).closest('form')); // Reset color picker values.
      });
    },

    /**
     * Updates the preview elements based on the name and color provided.
     *
     * This function is designed to update the visual aspects of certain elements based on the selected colors.
     * It is capable of handling updates for the logo's background color, the primary background color, and the font color.
     * The function distinguishes the target element by the 'name' parameter and applies the provided 'color' to it.
     *
     * @param {string} name - The name identifier for the element whose color is to be updated.
     *                        Expected values are 'logoBackground', 'primaryColor', and 'fontColor'.
     * @param {string} color - The hex color code to be applied to the element identified by the 'name'.
     *
     * Operation:
     * - If 'name' is 'logoBackground', it hides the default message in the dropify logo container
     *   and updates the background color of the dropify preview area for the logo.
     * - If 'name' is 'primaryColor', it invokes the setFontPreview function with the 'color' parameter
     *   to update the primary background color.
     * - If 'name' is 'fontColor', it again calls setFontPreview with the 'color' parameter to update the font color.
     *
     * Notes:
     * - The setFontPreview function is assumed to adjust the font preview based on the parameters passed to it,
     *   aligning the preview with the newly selected color.
     * - This method is particularly useful in contexts where a user interface allows dynamic customization of elements
     *   like logos, backgrounds, and fonts based on user selection.
     */
    updatePreview: function (name, color) {
      // Check if the picked color is for the logo's background
      if (name === 'logoBackground') {

        const $dropifyLogo = $('.dropify-logo');

        $('.dropify-wrapper', $dropifyLogo).css({
          'background-color': color
        });

        $('.dropify-preview', $dropifyLogo).css({
          'background-color': color
        });

      }
      // Check if the picked color is for the primary background
      if (name === 'primaryColor') {
        this.setFontPreview('', color);
      }

      // Check if the picked color is for the font
      if (name === 'fontColor') {
        this.setFontPreview('', '', color);
      }
    },

    /**
     * Updates the preview element with the selected font attributes.
     *
     * This function applies the provided font family, background color, and text color
     * to a preview element, allowing users to see how their font choices will look.
     * Each parameter is optional; only provided values will be applied, allowing for
     * partial updates to the preview's style.
     *
     * @param {string} [fontFamily=''] The font family to apply to the preview element. If empty, no change is made.
     * @param {string} [backgroundColor=''] The background color to apply to the preview element. If empty, no change is made.
     * @param {string} [color=''] The text color to apply to the preview element. If empty, no change is made.
     */
    setFontPreview: function (fontFamily = '', backgroundColor = '', color = '') {
      if (fontFamily !== '') {
        __this.$fontPreview.css(
            {
              'font-family': fontFamily,
            }
        );
      }
      if (backgroundColor !== '') {
        __this.$fontPreview.css(
            {
              'background-color': backgroundColor,
            }
        );
      }
      if (color !== '') {
        __this.$fontPreview.css(
            {
              'color': color
            }
        );
      }
    },
    /**
     * Initializes the color picker widget with predefined options.
     *
     * This function sets up a color picker on elements matching the `.input-color-picker` selector.
     * The color picker is configured with a 'polaroid' theme in 'light' mode, and a set of predefined
     * swatch colors. This allows users to select a color from a palette or define a custom one.
     */
    initColorPicker: function () {
      // Regular color fields use the default light theme
      Coloris({
        el: '.input-color-picker',
        theme: 'polaroid',
        themeMode: 'light',
        alpha: false,
        swatches: [
          '#264653',
          '#2a9d8f',
          '#e9c46a',
          '#f4a261',
          '#e76f51',
          '#d62828',
          '#023e8a',
          '#0077b6',
          '#0096c7',
          '#00b4d8',
          '#48cae4'
        ]
      });
    },
    /**
     * Sets default values for color pickers within a specified context or globally if no context is provided.
     * This function iterates over each color picker element, applies the default values, and triggers an input event.
     *
     * @param {Object} defaults - An object containing default values for color pickers, keyed by the color picker's name.
     * @param {jQuery} [$context] - An optional jQuery object specifying the context in which to find color picker inputs. If not provided, the global document context is used.
     */
    setDefaultsForColorPicker: function (defaults, $context) {
      let __view = this;
      let $colorPickers = $('.input-color-picker');
      if ($context) {
        $colorPickers = $('.input-color-picker', $context);
      }
      // Set defaults for color picker
      $colorPickers.each(function () {
        let $this = $(this);
        $this.val(defaults[this.name]);
        __view.updatePreview(this.name, defaults[this.name]);
        $this[0].dispatchEvent(new Event('input', {bubbles: true}));
      });
    },
    /**
     * Defines and returns a list of default preferences for certain UI elements or functionality.
     * These preferences include settings for emojis, links, call options, numbers, meeting options, and private messaging.
     *
     * @return {Array} Returns an array of objects, each representing a default preference with its corresponding settings.
     */
    preferencesDefault: function () {
      const options = [
        {"tag": "{EMOJI|}", "value": true},
        {"tag": "{LINK|}", "value": ""},
        {
          "cta": true,
          "tag": "{CALL_OPTION|}",
          "enabled": false,
          "value": "Call or text"
        },
        {"cta": true, "tag": "{NUMBER|}", "enabled": false, "value": "000-000-0000"},
        {
          "cta": true,
          "tag": "{MEET_OPTION|}",
          "enabled": false,
          "value": "a consultation"
        },
        {"cta": true, "tag": "{PM_OPTION|}", "enabled": false, "value": "PM"}
      ];
      return options;
    },

    /**
     * Renders hashtag elements within a container based on the provided configuration.
     * This function empties the hashtags container before appending new hashtag rows based on the config data.
     * It assumes the existence of certain elements and configurations like templates and options.
     *
     * @param {Object} values - An object containing configuration data, including hashtags and options for rendering.
     */
    renderHashTags: function (values) {
      __this.$hashtagsContainer.empty();
      app.hideToast();
      if (!app.isEmpty(values) && !app.isEmpty(values.config)) {
        if (!app.isEmpty(values.config.hashtags)) {
          const hashtags = values.config.hashtags;
          const hashtagRow = _.template(app.templates['business_profile__hashtag-row']);
          if (!app.isEmpty(hashtags)) {
            Utils.setSwitchVal(__this.$switchHashTag, true);
            $.each(hashtags, function (index, value) {
              let $row = $(hashtagRow({'name': app.sanitizeHashtag(value)}));
              $row.appendTo(__this.$hashtagsContainer);
            });
          }
        }
      }
    },

    setPreferences(preferences) {
      preferences = _.indexBy(preferences, 'tag');

      $('[data-tag]').each(function () {
        const $this = $(this);
        const $tag = $this.attr('data-tag');
        let elementType = $this[0].type;

        // Check if textarea or select
        if (app.isEmpty(elementType)) {
          elementType = $this[0].tagName;
        }

        if (!app.isEmpty(preferences[$tag]) && !app.isEmpty(preferences[$tag]['value'])) {
          const value = preferences[$tag]['value'];
          const sampleType = $this.attr('data-type');
          let $collapse = false;

          if (elementType === 'checkbox') {
            $this.prop('checked', value);
          }

          if (app.isEmpty(sampleType) && (elementType === 'text' || elementType === 'textarea')) {
            $this.val(value);
            $collapse = $this.closest('[data-collapse]');
          }

          if (!app.isEmpty(sampleType) && sampleType === 'sample' && preferences[$tag]['enabled']) {
            Sample.setElementValue($this, value);
            $collapse = $this.closest('[data-collapse]');
          }

          if ($collapse.length) {
            const $checkboxSwitch = $(`[data-tag="${$collapse.attr('data-collapse')}"]`);
            Utils.setSwitchVal($checkboxSwitch, true);
          }
        }
      })
    },

    setLearn(mergeTags) {

      const groupedMergeTags = getSamplesData(mergeTags);
      _.each(groupedMergeTags, function (mergeTagsByType, type) {
        _.each(mergeTagsByType, function (mergeTags, index) {
          if (!app.isEmpty(mergeTags)) {
            const sampleIndex = parseInt(index) + 1;
            const sampleNav = $(`[data-sample-container="${type}__${sampleIndex}"]`);
            const sample = $(sampleNav.attr('data-bs-target'));

            sample.find('[data-tag]').each(function () {
              const $this = $(this);
              const $tag = $this.attr('data-tag');
              const sampleType = $this.attr('data-type');

              if (!app.isEmpty(mergeTags[$tag])) {
                const value = mergeTags[$tag]['value'];
                if (!app.isEmpty(sampleType) && sampleType === 'sample') {
                  Sample.setElementValue($this, value);
                }
              }
            });

            const sampleObject = new Sample(sample);
            sampleObject.validate();
          }
        });
      });
    },

    reset: function () {
      const preferencesDefaults = [
        {
          "tag": "{EMOJI|}",
          "value": true
        },
        {
          "tag": "{LINK|}",
          "value": ""
        },
        {
          "cta": true,
          "tag": "{CALL_OPTION|}",
          "enabled": false,
          "value": "Call or text"
        },
        {
          "cta": true,
          "tag": "{NUMBER|}",
          "enabled": false,
          "value": "000-000-0000"
        },
        {
          "cta": true,
          "tag": "{MEET_OPTION|}",
          "enabled": false,
          "value": "a consultation"
        },
        {
          "cta": true,
          "tag": "{PM_OPTION|}",
          "enabled": false,
          "value": "PM"
        }
      ];

      this.setPreferences(preferencesDefaults);
    },

    /**
     * Populate business_profile
     */
    setValues: function (values) {
      const self = this;
      app.clearDropify();
      // Info
      $(':input[name=id]', __this.$form).val(values.id);
      $(':input[name=industry]', __this.$form).val(values.industry).trigger('change');
      $(':input[name=name]', __this.$form).val(values.name);
      $(':input[name=company]', __this.$form).val(values.company);
      $(':input[name=zip]', __this.$form).val(values.zip);
      $(':input[name=first]', __this.$form).val(values.first);
      $(':input[name=last]', __this.$form).val(values.last);

      // Hashtags, Graphics
      let options, hashtags, graphics, mergeTags;
      if (!app.isEmpty(values) && !app.isEmpty(values.config)) {
        if (!app.isEmpty(values.config.options)) {
          options = values.config.options;
        }

        if (!app.isEmpty(values.config.mergeTags)) {
          mergeTags = values.config.mergeTags;
        }

        this.setPreferences(options);

        if (!app.isEmpty(values.config.graphics)) {
          graphics = app.clone(values.config.graphics);
        }
      }

      // Hashtags,
      this.renderHashTags(values);

      // Graphics
      if (!_.isEmpty(graphics)) {
        let colors = app.clone(__this.colorDefaults);
        _.each(colors, function (color, key) {
          color = graphics.colors.shift();
          colors[key] = color;
        });
        this.setDefaultsForColorPicker(colors);

        __this.$fontType.val(graphics.font).trigger('change');

        // Grphics Logo and headshot
        if (!app.isEmpty(graphics.headshot) && !app.isEmpty(graphics.headshot)) {
          this.setDropifyVal($('.dropify-headshot'), graphics.headshot.img)
          __this.headshot = {
            img: graphics.headshot.img,
            thumb: graphics.headshot.thumb
          };
        }

        // Graphics Logo and headshot
        if (!app.isEmpty(graphics.image) && !app.isEmpty(graphics.image)) {
          this.setDropifyVal($('.dropify-logo'), graphics.image.img)
          __this.logo = {
            img: graphics.image.img,
            thumb: graphics.image.thumb
          };
        }
      }

      __this.getCampaignByIndustry.then(function (response) {
        self.setLearn(mergeTags);
      });

    },
    /**
     * Sets the value of a Dropify input within a specified context by updating the preview image and making the remove image button visible.
     * This function is particularly useful for dynamically updating the preview of a Dropify file input based on a specific value (e.g., a URL to an image).
     * It assumes the Dropify plugin is initialized in the specified context.
     *
     * @param {jQuery} $container - The jQuery object specifying the context in which the Dropify input is located. This helps in targeting specific instances of Dropify inputs within a page.
     * @param {string} value - The value to set for the Dropify input. Typically, this would be a URL to an image that is to be displayed as the current preview.
     */
    setDropifyVal: function ($container, value) {
      const $preview = $('.dropify-preview', $container);
      const $wrapper = $('.dropify-wrapper', $container);

      if (!app.isEmpty(value)) {
        const $render = $('.dropify-render', $preview);
        const $img = $('<img />').attr('src', value);
        const $uploadButton = $('.dropify-actions.btn-upload-image', $container);
        const $removeButton = $('.dropify-actions.btn-remove-image', $container);
        const $message = $('.dropify-message', $container);

        $render.empty();
        $removeButton.removeClass('d-none');
        $uploadButton.addClass('d-none');
        $message.hide();
        $img.appendTo($render);
        $preview.show();
      } else {
        const $actions = $('.dropify-actions', $container);
        const $message = $('.dropify-message', $container);

        $actions.addClass('d-none');
        $message.show();
        $preview.hide();
      }

    },
    /**
     * Dynamically populates header tabs based on a provided list of tab data.
     * This function empties the container for header tabs and iterates through the 'tabs' array,
     * creating and inserting tab elements using a predefined template. After insertion, it updates
     * icons or graphics within the tabs using the 'feather.replace()' method, assuming the use of Feather icons.
     *
     * @param {Array<Object>} tabs - An array of objects, each representing the data required to render a tab.
     * The exact structure of these objects depends on the template 'global__header-nav-item'.
     */
    setHeaderTabs: function (tabs) {
      const $container = $('.header-tabs-start');
      $container.empty();
      _.each(tabs, function (tab) {
        const page = _.template(app.templates['global__header-nav-item']);
        const $page = $(page(tab));
        $page.appendTo($container);
      });
    },
    /**
     * Inserts a group of graphics into a specified container.
     * This function uses a predefined template to render graphics based on the provided 'data',
     * then appends the rendered graphics to the given '$container'.
     * It's designed to support dynamic UI updates, particularly for business profiles or similar sections where groups of related graphics or icons may be displayed.
     *
     * @param {jQuery} $container - The jQuery object of the container into which the graphics group will be added. This parameter specifies where in the DOM the rendered graphics should be appended.
     * @param {Object} data - The data object used to populate the template. The structure of this object should match the requirements of the 'business_profile__group-graphics' template.
     */
    addGraphicsGroup: function ($container, data) {
      const page = _.template(app.templates['business_profile__group-graphics']);
      const $page = $(page(data));
      $container.append($page);
    },

    dropify: function (namespace, $container) {
      const self = this;
      const title = namespace === 'headshot' ? 'Headshot' : 'Logo';
      const inputName = namespace === 'headshot' ? 'headshot' : 'logo';

      const options = {
        namespace: 'single-uploader', // Namespace for dropify instance
        title: `Upload ${title}`,  // Title for the input field
        input: inputName, // ID and name of the input field
        preview: false,
        multiple: false,
        button: false,
        autoupload: true
      }
      const $uploader = new Uploader(app, $container, options, null);

      const submitForm = async (input) => {
        const $form = input.closest('form');
        // Create a new 'submit' event
        const event = new Event('submit', {
          bubbles: true,    // The event will bubble up through the DOM
          cancelable: true  // The event can be canceled
        });
        $form[0].dispatchEvent(event);
        return $form;
      }

      const onFormSubmitComplete = function () {
        // Return a promise that resolves when the value changes
        return new Promise((resolve) => {
          // This function simulates the value change
          function checkValue() {
            // Simulate a condition check, e.g., value change
            if (__this.dropifyInProgress === false) {
              resolve(__this);
            } else {
              // Re-check the value every 100ms
              setTimeout(checkValue, 100);
            }
          }

          // Start checking the value
          checkValue();
        });
      }

      const removeCallback = function (input, $button) {
        const name = input.attr('name');
        if (name === 'headshot') {
          __this.headshot = {};
        }
        if (name === 'logo') {
          __this.logo = {};
        }

        __this.dropifyInProgress = true;
        app.button($button, 'loading');

        submitForm(input.closest('form')).then(function () {
        })

        onFormSubmitComplete().then(function () {
          app.doButtonReset($button);
          self.setDropifyVal($container, '');
        })
      }

      const uploadCallback = async function (input, $button) {
        const file = input[0].files[0];

        app.doButtonAction($button);
        const response = await app.apis['uploads'].upload(file);

        const name = input.attr('name');
        if (name === 'headshot') {
          __this.headshot = {
            img: response.path,
            thumb: response.pathThumbnail
          };
        }
        if (name === 'logo') {
          __this.logo = {
            img: response.path,
            thumb: response.pathThumbnail
          };
        }

        __this.dropifyInProgress = true;
        submitForm(input.closest('form')).then(function () {

        });

        onFormSubmitComplete().then(function () {
          app.doButtonReset($button);
          self.setDropifyVal($container, response.path)
        })
      }


      return $uploader.dropifySingle(removeCallback, uploadCallback);
    },

    /**
     * Creates a custom dropdown for font selection, populated with Google Fonts, enhancing a select input.
     *
     * @param {jQuery} $input - The jQuery DOM element of the select input to be enhanced into a font selection dropdown.
     */
    createFontsDropDown: function ($input) {
      // Accumulates font families from the options within the select input.
      let fontFamilies = [];
      $('optgroup[label!="System"] option', $input).each(function () {
        var font = $(this).val().replace(', sans-serif', '').replace(', serif', '').replace("'", '').replace("'", '');
        fontFamilies.push(font);
      });

      // Loads the Google Fonts specified in the fontFamilies array.
      __this.loadGoogleFonts(fontFamilies);

      // Initializes Select2 plugin with custom formatting for the font options.
      __this.initFontSelect2 = function () {
        __this.fontFormatState = function (state) {
          if (!state.id) {
            return state.text;
          }
          return $('<span style="font-family:' + state.element.value + ';">' + state.text + '</span>');
        };

        let fieldNameSelect2 = function () {
          return $input.select2({
            dropdownCssClass: 'font-select2-dropdown',
            selectionCssClass: 'font-select2-selection',
            theme: 'bootstrap-5', templateResult: __this.fontFormatState
          });
        };

        fieldNameSelect2();
      };

      // Calls the initialization function for the Select2 plugin customization.
      __this.initFontSelect2();
    },
    /**
     * Builds and appends sample elements to their respective containers based on character length.
     * This function processes an array of sample texts, divides them into two categories based on character length
     * (over 280 characters and under 280 characters), and then appends the processed samples to specific containers in the DOM.
     * The processing of each sample involves applying a template and possibly incorporating dynamic option values and campaign-specific options.
     *
     * @param {Array} samples - An array of sample text strings to be processed.
     * @param {Object} optionValues - An object containing values that might be used to dynamically adjust the samples.
     * @param {Object} campaignOptions - An object with options specific to the campaign that might affect how samples are processed.
     *
     * The function does not return a value but instead has side effects including manipulating the DOM by appending processed samples to specified containers.
     * It assumes the existence of a global `app` object with a `templates` property that includes a template named 'business_profile__samples',
     * a `$samplesContainerOver280` property for appending samples over 280 characters,
     * and a `$samplesContainerUnder280` property for appending samples under 280 characters.
     * Additionally, it relies on the jQuery library for DOM manipulation and the Lodash library for the template function.
     *
     * Note: This function uses `$.each` for iteration, implying a dependency on jQuery. It also uses the `_.template` method from Lodash,
     * indicating that both jQuery and Lodash should be included in the project.
     *
     * @example
     * // Assume `samples` is an array of text samples, `optionValues` contains options that might modify the samples,
     * // and `campaignOptions` contains campaign-specific modifiers.
     * buildSamples(samples, optionValues, campaignOptions);
     *
     * // This will process the `samples` array, divide it based on character count criteria, and append processed samples
     * // to their respective containers within the DOM.
     */
    buildSamples: function (samples, optionValues, campaignOptions) {
      __this.$samplesContainerUnder280.empty();
      __this.$samplesContainerOver280.empty();
      if (app.isEmpty(samples)) {
        // Hide learn tab
        Utils.hideTab('#tab_block_4');

      } else {
        Utils.showTab('#tab_block_4');
        let self = this;
        const businessSamples = _.template(app.templates['business_profile__samples']);
        const over280 = samples.slice(0, 4);
        const under280 = samples.slice(4);

        $.each({'over280': over280, 'under280': under280}, function (key, data) {

          let samplesData = {'prefix': key};
          const $container = key === 'over280' ? __this.$samplesContainerOver280 : __this.$samplesContainerUnder280;
          $.each(data, function (index, sample) {
            const sampleIndex = index + 1;
            let $sample = Sample.parseSample(sample, optionValues, campaignOptions);
            samplesData[`sample${sampleIndex}`] = $sample.join(' ');
          });

          let $businessSamples = $(businessSamples(samplesData));
          $businessSamples.appendTo($container);
        });

        this.setSampleActiveTab();
      }

    },

    setSampleActiveTab: function () {
      const $tab = $('.sample-navs').closest('.tab-pane-samples.active');
      const $navs = $('.sample-navs', $tab);
      const $activeNav = $('.nav-link.active', $navs);
      __this.activeTab = $activeNav.attr('data-bs-target');
      __this.$acitveTabContent = $(`${__this.activeTab}`);
      aimi_samples.setSampleContainer(__this.$acitveTabContent);
      return __this.$acitveTabContent;
    },

  }
}(window.aimi_business_profile = window.aimi_business_profile || {}, jQuery, PreBuilt));
